// extracted by mini-css-extract-plugin
export default {"fab":"FloatingActionButton_fab__R1kUF","icon":"FloatingActionButton_icon__qYgpd"};